import { organisationConstants } from '../../_constants/organisation.constants';
const initialState = { demographic_download_load : true, demographic_download_data: '', demographic_download_error: false};

export function downloadDemographicData(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_DEMOGRAPHIC_DOWNLOAD:
        return {
            delete_report_loading: true,
            delete_report: '',
            delete_report_error: false
        };
      case organisationConstants.RESPONSE_DEMOGRAPHIC_DOWNLOAD:
        return {
            delete_report_loading: false,
            delete_report: action.demographic_download,
            delete_report_error: false
        };
      case organisationConstants.ERROR_DEMOGRAPHIC_DOWNLOAD:
        return { 
            delete_report_loading: false,
            delete_report: '',
            delete_report_error: true
        };
      default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/organisation/demographicDownload.reducer.js